import { resource } from '@util/resource';
import { Observable } from 'rxjs';
import { Injectable} from '@angular/core';
import { WineSuiteParameters } from "../../interfaces/dws/wine-suite-parameters";
import { AdminLoginAsWineryService } from './admin-login-as-winery.service';


@Injectable({
  providedIn: 'root'
})
export class WineSuiteParametersService {
  constructor(private adminLoginAsWineryService: AdminLoginAsWineryService) {}

  editWineSuiteParameters(wineSuiteParameters: WineSuiteParameters): Observable<unknown> {
    const adminToken = this.adminLoginAsWineryService.getOriginalAdminToken();
    if (adminToken) {
      return resource('crm://admin/ws-parameters')
        .bearer(adminToken.replace('Bearer ', ''))
        .post(wineSuiteParameters);
    }
    return resource('crm://admin/ws-parameters')
        .headers({ 'x-admin-authorization': '1' })
        .post(wineSuiteParameters);
  }

  showWineSuiteParameters(): Observable<WineSuiteParameters> {
    return resource('crm://ws-parameters').get();
  }
}
